import { recordFromSnapshot } from 'utils/firebaseUtils'
import moment from 'moment'
import _ from 'lodash'
// ------------------------------------
// Constants
// ------------------------------------
export const CREATE_PRODUCT_ERROR = 'CREATE_PRODUCT_ERROR'
export const CREATE_PRODUCT_SUCCESS = 'CREATE_PRODUCT_SUCCESS'
export const DELETE_PRODUCT_ERROR = 'DELETE_PRODUCT_ERROR'
export const DELETE_PRODUCT_SUCCESS = 'DELETE_PRODUCT_SUCCESS'
export const UPDATE_PRODUCT_ERROR = 'UPDATE_PRODUCT_ERROR'
export const UPDATE_PRODUCT_SUCCESS = 'UPDATE_PRODUCT_SUCCESS'
export const SELECT_PRODUCT = 'SELECT_PRODUCT'

// ------------------------------------
// Logic Actions
// ------------------------------------
export function selectProduct(product) {
  return (dispatch, getState) => {
    dispatch({
      type: SELECT_PRODUCT,
      payload: product
    })
  }
}
export function reorderProducts(orderedProducts) {
  return (dispatch, getState) => {
    const { firebase } = getState()
    let fanoutObject = {}
    let counter = 1
    orderedProducts.forEach(p => {
      fanoutObject['/products/' + p.key + '/order'] = counter
      counter++
    })
    firebase.update(fanoutObject)
  }
}
// ------------------------------------
// Basic Actions
// ------------------------------------
export function createProduct({
  name,
  stockManagement,
  category,
  color,
  tva,
  price
}) {
  return (dispatch, getState) => {
    const { firebase, products, auth } = getState()
    let nextOrder = 0
    const filteredProducts = products.list.filter(
      p => p.category.key === category.key
    )
    filteredProducts.forEach(p => {
      if (nextOrder < p.order) {
        nextOrder = p.order
      }
    })
    nextOrder++
    const now = moment().format()
    const product = {
      createdBy: auth.hbUserKey,
      updatedBy: auth.hbUserKey,
      createdAt: now,
      updatedAt: now,
      name: name,
      category: category,
      price: price,
      stockManagement: stockManagement,
      color: color,
      tva: tva,
      order: nextOrder
    }
    firebase.child('products/').push(product, error => {
      if (error) {
        console.error('ERROR @ createPRODUCT :', error)
        dispatch({
          type: CREATE_PRODUCT_ERROR,
          payload: error
        })
      }
    })
  }
}
export function deleteProductsOld(productsDel) {
  return (dispatch, getState) => {
    const { firebase, products } = getState()
    let fanoutObject = {}
    productsDel.forEach(prodDel => {
      const productsCat = products.list.filter(
        p => p.category === prodDel.category
      )
      let counter = 1
      productsCat.forEach(p => {
        if (!productsDel.find(pc => pc.key === p.key && pc.order === p.order)) {
          fanoutObject['/products/' + p.key + '/order'] = counter
          counter++
        } else {
          fanoutObject['/products/' + p.key] = null
        }
      })
    })
    firebase.update(fanoutObject)
  }
}
export function deleteProducts(productsDel) {
  return (dispatch, getState) => {
    const { firebase, products } = getState()
    productsDel = _.isArray(productsDel) ? productsDel : [productsDel]
    let fanout = {}
    let counter = 1
    products.list.forEach(p => {
      if (!productsDel.find(e => e.key === p.key && e.order === p.order)) {
        fanout['/products/' + p.key + '/order'] = counter
        counter++
      } else {
        fanout['/products/' + p.key] = null
      }
    })
    firebase.update(fanout, error => {
      if (error) {
        console.error('ERROR @ deleteCategory :', error)
        dispatch({
          type: DELETE_PRODUCT_ERROR,
          payload: error
        })
      }
    })
  }
}
export function deleteProduct(product) {
  return (dispatch, getState) => {
    const { firebase } = getState()
    firebase.child('products/' + product.key).remove(error => {
      if (error) {
        console.error('ERROR @ createTABLE :', error)
        dispatch({
          type: DELETE_PRODUCT_ERROR,
          payload: error
        })
      }
    })
  }
}

export function updateProduct(product, changes) {
  return (dispatch, getState) => {
    const { firebase } = getState()
    firebase.child('products/' + product.key).update(changes, error => {
      if (error) {
        console.error('ERROR @ updateProduct :', error)
        dispatch({
          type: UPDATE_PRODUCT_ERROR,
          payload: error
        })
      }
    })
  }
}
// export function updateAllProducts () {
//   return (dispatch, getState) => {
//     let fanoutObject = {}
//     const { firebase, products } = getState()
//     products.list.forEach(p => {
//       fanoutObject['/products/'+p.key+'/price'] = Number(p.price)
//     })
//     firebase.update(fanoutObject)
//   }
// }
export function registerProductsListeners() {
  return (dispatch, getState) => {
    const { firebase } = getState()
    const ref = firebase.child('products').orderByChild('order')

    ref.on('child_added', snapshot => {
      dispatch({
        type: CREATE_PRODUCT_SUCCESS,
        payload: recordFromSnapshot(snapshot)
      })
    })

    ref.on('child_changed', snapshot =>
      dispatch({
        type: UPDATE_PRODUCT_SUCCESS,
        payload: recordFromSnapshot(snapshot)
      })
    )

    ref.on('child_removed', snapshot =>
      dispatch({
        type: DELETE_PRODUCT_SUCCESS,
        payload: recordFromSnapshot(snapshot)
      })
    )
  }
}

export const actions = {
  createProduct,
  updateProduct,
  registerProductsListeners
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [CREATE_PRODUCT_SUCCESS]: (state, action) => {
    let list
    const tmpList = state.list.filter(
      product => product.key === action.payload.key
    )
    if (tmpList.length === 0) {
      list = [...state.list, action.payload]
    } else {
      list = [...state.list]
    }
    return Object.assign({}, state, { list: list })
  },
  [CREATE_PRODUCT_ERROR]: (state, action) =>
    Object.assign({}, state, { error: action.payload }),
  [UPDATE_PRODUCT_SUCCESS]: (state, action) => {
    state.list.map(
      product => (product.key === action.payload.key ? action.payload : product)
    )
    return Object.assign({}, state, {
      list: state.list.map(product => {
        return product.key === action.payload.key ? action.payload : product
      })
    })
  },
  [UPDATE_PRODUCT_ERROR]: (state, action) =>
    Object.assign({}, state, { error: action.payload }),
  [DELETE_PRODUCT_SUCCESS]: (state, action) =>
    Object.assign({}, state, {
      list: state.list.filter(product => {
        return product.key !== action.payload.key
      })
    }),
  [DELETE_PRODUCT_ERROR]: (state, action) =>
    Object.assign({}, state, { error: action.payload }),
  [SELECT_PRODUCT]: (state, action) =>
    Object.assign({}, state, { selectedProduct: action.payload })
}
// ------------------------------------
// Reducer
// ------------------------------------
const initialState = { list: [], selectedProduct: {} }
export default function productReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]

  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/redux/modules/product.js